export default "__VITE_ASSET__e485c3c9__"